import * as React from "react";
import {none, Option, some} from "ts-option";
import PageHeaderView from "../../body/PageHeaderView";
import PageContentView from "../../body/PageContentView";
import Loading from "../../ui/loading/Loading";
import {api} from "../../../api/api";
import HistoricalJobImport from "../../../model/historicalJobImport/HistoricalJobImport";
import HistoricalJobImportsTable from "./HistoricalJobImportsTable";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import UploadHistoricalJobsModal from "./UploadHistoricalJobsModal";

interface IState {
	items: Option<HistoricalJobImport[]>;
	uploadModalVisible: boolean;
}

export default class HistoricalJobImportsList extends React.PureComponent<{}, IState> {

	constructor(props: {}) {
		super(props);
		this.state = {items: none, uploadModalVisible: false};
	}

	componentDidMount(): void {
		this.fetchItems();
	}

	render() {
		return (
			<div>
				<PageHeaderView header={"Historical Jobs"}>
					<ButtonPrimary onClick={this.openUploadModal}
								   label={"Upload Historical Jobs"}
								   variant={"burgundy"}/>
				</PageHeaderView>
				<PageContentView>
					<Loading isLoading={this.state.items.isEmpty}>
						<HistoricalJobImportsTable items={this.state.items.getOrElse([])}/>
					</Loading>
				</PageContentView>
				{this.state.uploadModalVisible &&
				<UploadHistoricalJobsModal onSuccess={this.onUploadSuccess} onCancel={this.closeUploadModal}/>}
			</div>
		);
	}

	private fetchItems() {
		this.setState({items: none});
		api.instance.historicalJobImportApi.getHistoricalJobImports()
			.then(items => this.setState({items: some(items)}))
			.catch(error => {
				notifyBugsnagAndShowToast(error, "Fetch historical job imports");
				this.setState({items: some([])});
			});
	}

	private openUploadModal = () => this.setState({uploadModalVisible: true});

	private closeUploadModal = () => this.setState({uploadModalVisible: false});

	private onUploadSuccess = () => this.setState({uploadModalVisible: false}, () => this.fetchItems());
}
